import { useCallback, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { sortBy } from 'lodash-es';
import { SimpleTable } from '../../../components/table/SimpleTable';
import { DownloadLink } from './DownloadLink.jsx';
import { Dialog } from '../../../components/Dialog';

export function RawFiles({ rawFiles, scrollTop, handleScroll }) {
  const [details, setDetails] = useState();
  const containerRef = useCallback(
    (node) => {
      if (node) {
        node.scrollTop = scrollTop;
      }
    },
    [scrollTop],
  );

  function showDetails() {
    return details ? (
      <Dialog
        title="Metadata"
        onCancel={() => setDetails(null)}
        actions={false}
        width="md"
      >
        <Box sx={{ minHeight: 400 }}>
          <Box
            component="pre"
            sx={{
              backgroundColor: 'grey.100',
              p: 2,
              borderRadius: 1,
              overflow: 'auto',
              fontSize: '0.875rem',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap',
            }}
          >
            {JSON.stringify(details, null, 2)}
          </Box>
        </Box>
      </Dialog>
    ) : null;
  }

  return rawFiles?.length ? (
    <>
      {showDetails()}
      <SimpleTable
        rows={sortBy(rawFiles, 'file').map((file) => ({
          'Raw File': <DownloadLink url={file.file} />,
          Format: file?.format,
          Converter: (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <span>{file.convertedBy}</span>
              {file.metadata.leaf ? (
                <IconButton
                  onClick={() => setDetails(file.metadata.leaf)}
                  size="small"
                  sx={{ padding: 0, color: 'inherit' }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              ) : null}
            </Box>
          ),
          Crop: file.crop,
          Year: file.year,
          Area: Number(file.area).toFixed(2),
          ...getStats(file.stats),
        }))}
        ref={containerRef}
        onScroll={handleScroll}
        sx={{
          maxHeight: 300,
          overflow: 'auto',
          '& .MuiTableCell-root': {
            py: 0.5,
            px: 1,
            fontSize: '0.875rem',
          },
          '& .MuiTableHead-root': {
            position: 'sticky',
            top: 0,
            backgroundColor: 'background.paper',
            zIndex: 1,
          },
        }}
      />
    </>
  ) : null;
}

function getStats(stats) {
  const [first] = Object.values(stats || {});

  return {
    Count: first?.count?.toLocaleString(),
    Avg: first?.avg?.toLocaleString(),
    Min: first?.min?.toLocaleString(),
    Max: first?.max?.toLocaleString(),
  };
}
